import { createReducer } from '@reduxjs/toolkit'

import { IDashboardExample } from 'types/GlobalDashboardExample'

import * as actions from '../../actions/DashboardExamples/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

import { insertItems } from 'redux/utils'

import { TFetchStatus } from 'redux/reducers/Dashboards'

interface DashboardBody {
  [dashboardId: string]: IDashboardExample
}

export interface DashboardExampleReducerType {
  data: DashboardBody
  nr_of_customers: number
  fetchStatus: TFetchStatus
}

// Initial state
const INITIAL_STATE: DashboardExampleReducerType = {
  data: {},
  nr_of_customers: 0,
  fetchStatus: 'idle'
}

// Reducer
const dashboardReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAll, (state) => {
      state.fetchStatus = 'fetching'
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      state.data = insertItems(action.payload.dashboards)
      state.nr_of_customers = action.payload.nr_of_customers
      state.fetchStatus = 'success'
    })
    .addCase(actions.getAllFailed, (state) => {
      state.fetchStatus = 'error'
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default dashboardReducer
